// Utility functions
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) {
    return '0 B'; // Return a default string for invalid input
  }
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const formatDate = (timestamp) => {
  if (!timestamp) return '长期有效'
  return new Date(timestamp * 1000).toLocaleDateString('zh-CN')
}

export const calculateDaysLeft = (timestamp) => {
  if (!timestamp) return Infinity
  const now = new Date()
  const expire = new Date(timestamp * 1000)
  const diffTime = expire - now
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export const calculateUsagePercentage = (used, total) => {
  if (total === 0) return 0
  return Math.min((used / total * 100), 100)
}
